import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  height: 80px;
  position: relative;
  padding: 1em 1.5em 1em 92px;
  background: #4d005b;
  @media screen and ${Device.tablet} {
    font-size: 12px;
  }

  &.giftcard-banner .giftcard-callout {
    h2 {
      text-align: left;
      color: white;
      margin-top: 10px;
      @media screen and ${Device.laptopM} {
        font-size: 1.5em;
      }
      @media screen and ${Device.laptop} {
        font-size: 1.3em;
      }
      @media screen and ${Device.tablet} {
        margin-bottom: 8px;
        margin-top: 0;
        font-size: 1.2em;
      }
    }
  }

  button {
    float: right;
    margin-top: 0;
    text-transform: uppercase;
    padding: 12px 8% 8px;
    font-size: 1.5em;
    outline: none;
    border: none;
  }

  .redeem-btn .btn.btn-primary {
    @media screen and ${Device.tablet} {
      float: none;
      font-size: 1.25em;
    }
    @media screen and ${Device.mobileL} {
      float: none;
      font-size: 1em;
    }
  }

  .giftcard-image {
    position: absolute;
    top: 15%;
    left: 10px;
    height: 70%;
    z-index: 10;
  }
`;
